import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { config } from '../config/env';
import { clearProductsStatusNotificationModalSessionFlag } from '../utils/productsStatusNotificationSession';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,

      setToken: token => set({ token }),

      setUser: user => set({ user }),

      clearToken: () => {
        clearProductsStatusNotificationModalSessionFlag();
        set({ token: null, user: null });
      },

      isAuthenticated: () => !!get().token,

      login: async (email, password) => {
        try {
          const response = await fetch(`${config.API_BASE_URL}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password }),
          });

          const data = await response.json().catch(() => ({}));

          // Fluxo 2FA
          if (response.ok && data.requires_two_factor) {
            return {
              requiresTwoFactor: true,
              tempToken: data.temp_token,
              message: data.message,
            };
          }

          if (!response.ok) {
            let msg = data.error || data.message || 'Credenciais inválidas';
            // Não expor mensagens internas do servidor
            if (response.status >= 500) {
              msg = 'Serviço temporariamente indisponível. Tente novamente.';
            }
            // Sanitizar mensagens técnicas sem regex para evitar problemas de escape
            {
              const lower = String(msg || '').toLowerCase();
              if (
                lower.includes('sqlstate') ||
                lower.includes('pdoexception') ||
                lower.includes('stack trace') ||
                lower.includes('illuminate\\') ||
                lower.includes('symfony\\') ||
                lower.includes('queryexception')
              ) {
                msg = 'Falha ao processar sua solicitação. Tente novamente.';
              }
            }
            // Email não verificado
            if (response.status === 403 && (data.error || '').includes('E-mail não verificado')) {
              return { emailNotVerified: true, error: msg };
            }
            // Demais falhas
            return { success: false, error: msg, status: response.status };
          }

          // Sucesso com token
          if (data.access_token) {
            clearProductsStatusNotificationModalSessionFlag();
            set({ token: data.access_token });
            return { success: true, access_token: data.access_token, user: data.user };
          }

          // Caso raro: sucesso sem token
          return { success: false, error: 'Resposta inválida do servidor' };
        } catch (error) {
          return { success: false, error: error.message || 'Erro de rede' };
        }
      },

      logout: () => {
        clearProductsStatusNotificationModalSessionFlag();
        set({ token: null, user: null });
      },
    }),
    {
      name: 'auth-storage',
      // Persistir token e user (com role) para que o menu e permissões funcionem após refresh
      partialize: state => ({ token: state.token, user: state.user }),
    },
  ),
);
